import * as MainActions from './main.actoins';

export {MainActions};
